<div [loadingOverlay]="isLoading()">
	<app-components-togglepanel [(isOpen)]="isOpen" title="Publish Options" keepBodyInDomWhenClosed="true" toggleBody="true">
		<div class="card-body">
			<app-components-publish-options
				[customerId]="customer.CustomerId()"
				[partnerImplementationContactEmail]="customer.Partner.ImplementationContactEmail()"
				[userId]="user.UserId"
				(implementationOwnerChanged)="currentImplementationOwner.set($event)">
			</app-components-publish-options>
		</div>
		<app-tab-panel [displayMode]="tabPanelDisplayMode.horizontal">
			<app-lazy-tab title="Website">
				<div *tabContent>
					@if (isBoostabilityMakingChangesToTheSite()) {
						<app-components-managecustomer-cms
							[customerId]="customer.CustomerId()"
							[partnerId]="customer.PartnerId()"
							(cmsChange)="contentManagementSystemChanged($event)">
						</app-components-managecustomer-cms>
						<app-components-managecustomer-customeraccountgroup #cmsGroup [options]="{
							customerId: customer.CustomerId(),
							editableNotes: true,
							customerAccountTypes: cmsAccountTypes,
							isEnabled: true,
							showSaveButton: false,
							supressSaveMessage: true}">
						</app-components-managecustomer-customeraccountgroup>
					}
					<app-components-managecustomer-customeraccountgroup [options]="{
						customerId: customer.CustomerId(),
						editableNotes: true,
						customerAccountTypes: websiteAccountTypes,
						isEnabled: true,
						showSaveButton: false,
						supressSaveMessage: true
					}" />
				</div>
			</app-lazy-tab>
		</app-tab-panel>
	</app-components-togglepanel>
</div>